import axios from 'axios';
import { checkErrorResponse } from '../utils/helpers';

export const status = ({ id }) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  return axios
    .post(`${process.env.REACT_APP_API}/transaction/${id}/`, {}, { headers })
    .then(function (response) {
      return response.data;
    })
    .catch(error => {
      return checkErrorResponse(error.response);
    });
};
